import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ApiClient from '../../methods/api/apiClient';
import { toast } from 'react-toastify';
import Layout from "../../components/global/layout";
import FormControl from "../../components/common/FormControl";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { IoCloseOutline } from "react-icons/io5";
import { FiPlus } from "react-icons/fi";
import { Tooltip } from 'antd';
import methodModel from '../../methods/methods';
import loader from '../../methods/loader';

const EditContent = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    title: '',
    description: '',
    meta_description: '',
    meta_title: '',
    status: '',
    image: ''
  });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const history = useNavigate();

  useEffect(() => {
    fetchContentDetail();
  }, []);

  const fetchContentDetail = async () => {
    if (id) {
      loader(true)
      const response = await ApiClient.get('content/detail', { id });
      if (response.success) {
        setForm(response.data);
      }
      loader(false)
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    const { title, description } = form;
    if (!title || !description) {
      toast.error('All fields are required');
      return;
    }
    setLoading(true);
    loader(true)
    let response;
    if (form._id || id) {
      response = await ApiClient.put('content/update', { id, ...form });
    } else {
      response = await ApiClient.post('content/update', { form, id });
    }
    if (response.success) {
      toast.success('Content updated successfully');
      navigate('/content');
    }
    loader(false)
    setLoading(false);
  };

  const ImageUpload = (e) => {
    let files = e.target.files;
    let file = files.item(0);
    loader(true)
    ApiClient.postFormData('upload/image', { file: file }).then(res => {
      if (res.success) {
        setForm({ ...form, image: res?.fileName });
      }
      loader(false)
    });
  };

  return (
    <Layout>
      <form onSubmit={handleSubmit} autoComplete="one-time-code">
        <div className="pprofile1">
          <div className="flex items-center mb-8">
            <Tooltip placement="top" title="Back">
              <span
                onClick={() => history(-1)}
                className="!px-4 py-2 cursor-pointer flex items-center justify-center rounded-lg shadow-btn hover:bg-[#F3F2F5] border transition-all mr-3"
              >
                <i className="fa fa-angle-left text-lg"></i>
              </span>
            </Tooltip>
            <div>
              <h3 className="text-lg lg:text-2xl font-semibold text-[#111827]">
                {id ? 'Edit Content' : 'Add Content'}
              </h3>
            </div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <div className="mb-3">
              <FormControl
                type="text"
                name="title"
                label="Title"
                placeholder="Title"
                value={form.title}
                onChange={(e) => setForm((prev) => ({ ...prev, title: e }))}
                required
              />
              {submitted && !form.title && <div className="text-red-600">Title is required</div>}
            </div>
            <div className="mb-3">
              <label className="lablefontcls">Image
                {/* <span className="text-red-600"> *</span> */}
              </label>
              {form.image ?
                <div>
                  <span className="relative inline-block">
                    <img src={methodModel.noImg(form.image)} className="rounded-full h-20 w-20 block" />
                    <IoCloseOutline className="absolute top-2 -right-5 pointer hover:text-red-600" onClick={() => setForm((prev) => ({ ...prev, image: "" }))} size={25} />
                  </span>
                </div>
                :
                <label className={`flex items-center justify-center cursor-pointer text-black-800 bg-[#fff] focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 border-2 border-dashed border-gray-200 w-full`} style={{ gap: '8px' }}>
                  <FiPlus />
                  <input
                    id="dropzone-file"
                    type="file"
                    className="hidden"
                    onChange={ImageUpload}
                  />
                  Upload Image
                </label>
              }
              {/* {submitted && !form.image && <div className="text-red-600">Image is required</div>} */}
            </div>
          </div>
          <div className="mb-3">
            <label>Description <span className="text-red-600"> *</span></label>
            <ReactQuill theme="snow" value={form.description} onChange={(e) => setForm((prev) => ({ ...prev, description: e }))} required />
            {submitted && !form.description && <div className="text-red-600">Description is required</div>}
          </div>
          <div className="mb-3">
            <FormControl
              type="text"
              name="meta_title"
              label="Meta Title"
              placeholder=" Meta Title"
              value={form.meta_title}
              onChange={(e) => setForm((prev) => ({ ...prev, meta_title: e }))}
            />
          </div>
          <div className="mb-3">
            <label>Meta Description</label>
            <ReactQuill theme="snow" value={form.meta_description} onChange={(e) => setForm((prev) => ({ ...prev, meta_description: e }))} />
          </div>
          <div className="text-right">
            <button
              type="submit"
              className="text-white bg-[#F58D18] focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
              disabled={loading}
            >
              {loading ? 'Saving...' : id ? 'Update Content' : 'Add Content'}
            </button>
          </div>
        </div>
      </form>
    </Layout>
  );
};

export default EditContent;
